import React, {
  ReactNode,
  createContext,
  useCallback,
  useEffect,
  useState,
} from 'react';

type ViewportSize = [number, number];
const ViewportContext = createContext<ViewportSize>([0, 0]);
export default ViewportContext;
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
export const ViewportContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [viewportSize, setViewportSize] = useState([0, 0]);
  const handleResize = useCallback(() => {
    window.requestAnimationFrame(() => {
      setViewportSize([window.innerWidth, window.innerHeight]);
    });
  }, []);
  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [handleResize]);
  return (
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'number[]' is not assignable to type 'Viewpor... Remove this comment to see the full error message
    <ViewportContext.Provider value={viewportSize}>
      {children}
    </ViewportContext.Provider>
  );
};
